import { Connection } from "@solana/web3.js";
import { useEffect, useMemo, useState } from "react";

import { useNetworkConfig } from "../../contexts/app/config";
import { useRefreshContext } from "../../contexts/refresh";
import { STEP_NETWORK_CONFIG_MAP } from "../../utils/network";

export const useSolanaPerformance = () => {
  const { network } = useNetworkConfig();
  const connection = useMemo(() => new Connection(STEP_NETWORK_CONFIG_MAP[network].endpoint), [network]);
  const [degradedPerformance, setDegradedPerformance] = useState(false);
  const { refreshing } = useRefreshContext();

  useEffect(() => {
    void (async () => {
      if (!refreshing) {
        const data = await connection.getRecentPerformanceSamples(15);
        const totalTps = data.reduce((acc, val) => {
          return acc + val.numTransactions / val.samplePeriodSecs;
        }, 0);
        const avgTps = totalTps / data.length;
        setDegradedPerformance(avgTps < 1500);
      }
    })();
  }, [connection, refreshing]);

  return degradedPerformance;
};
